import type { ProductTrackingData } from '../models/domain/personalizedTracking';
import type { PriceData } from '../models/priceData/priceData';

import { Helpers } from '../../../utility/helpers';
import { PriceType } from '../models/priceData/priceData';
import { personalizationTracking } from '../tracking/contextAware/personalizationEvents';

interface QuantityChangeData extends Omit<ProductTrackingData, 'promotionPrice' | 'price'> {
    promotionPriceData?: PriceData;
    priceData?: PriceData;
}

const { trackCartItemQuantityUpdate, trackRemoveFromCart, trackAddToCart } =
    personalizationTracking;

const buyableProductEventsTrackingPriceType = PriceType.IncludeTax; // leave b2c prices for tracking

const onAddToCartTrack = (quantityChangeData: QuantityChangeData) => {
    trackAddToCart([
        mapToProductTrackingData(quantityChangeData, buyableProductEventsTrackingPriceType),
    ]);
};

const onQuantityUpdateTrack = (quantityChangeData: QuantityChangeData) => {
    if (quantityChangeData.quantity > quantityChangeData.previousQuantity) {
        trackCartItemQuantityUpdate(
            mapToProductTrackingData(quantityChangeData, buyableProductEventsTrackingPriceType),
        );
    }
};

const onRemoveFromCartTrack = (quantityChangeData: QuantityChangeData) => {
    trackRemoveFromCart(
        mapToProductTrackingData(quantityChangeData, buyableProductEventsTrackingPriceType),
    );
};

export const buyableProductEventsTracking = {
    onAddToCartTrack,
    onQuantityUpdateTrack,
    onRemoveFromCartTrack,
};

const mapToProductTrackingData = (
    quantityChangeData: QuantityChangeData,
    priceType: PriceType,
): ProductTrackingData => {
    return {
        identifier: quantityChangeData.identifier,
        price:
            quantityChangeData?.priceData &&
            Helpers.getPrice(quantityChangeData.priceData, priceType),
        quantity: quantityChangeData.quantity,
        previousQuantity: quantityChangeData.previousQuantity,
        promotionPrice:
            quantityChangeData?.promotionPriceData &&
            Helpers.getPrice(quantityChangeData.promotionPriceData, priceType),
    };
};
